/* eslint-disable no-irregular-whitespace */
import { cloudfrontUrl } from "../constants/imageUrl";
import { Category, Product, SideByCategory } from "../types/product";

export const categories = Object.values(Category).map((category) => ({
  key: category,
  label: category,
}));

export const products: Product[] = [
  {
    id: "signature-platter",
    name: "Plat signature",
    price: "44.0",
    category: Category.SIGATURE_PLATTER,
    description: `Une immersion dans l’univers KSM.`,
    images: [
      `${cloudfrontUrl}/food/signature_platter2.png`,
      `${cloudfrontUrl}/food/signature_platter.png`,
      `${cloudfrontUrl}/food/signature_platter3.png`,
    ],
    isVisible: true,
  },
  {
    id: "seoul-burger",
    name: "SEOUL BURGER",
    price: "14.5",
    category: Category.BURGER,
    description: `Hauts de cuisse de poulet désossés, assaisonnés de notre mélange d’épices secret,
cuits dans de l’huile de tournesol 100 % raffinée et servis dans un pain grillé beurré, avec des cornichons et la sauce KSM Sweet Mayonnaise.
`,
    images: [`${cloudfrontUrl}/food/classic_chicken_burger.png`],
    isVisible: true,
  },
  {
    id: "fire-chicken-burger",
    name: "FIRE CHICKEN BURGER",
    price: "15.5",
    category: Category.BURGER,
    description: `Un burger de poulet frit authentiquement coréen, accompagné d’une combinaison de sauce KSM Spicy, de sauce authentique épicée et de nos piments frits.
`,
    images: [`${cloudfrontUrl}/food/yangnyeom_chicken_burger.png`],
    isVisible: true,
  },
  {
    id: "bbq-burger",
    name: "BBQ BURGER",
    price: "15.5",
    category: Category.BURGER,
    description: `Inspiré du plat coréen Tonkatsu. Hauts de cuisse de poulet désossés, panés avec une chapelure coréenne.
Servis avec une combinaison de sauce spéciale Namsan BBQ et de sauce KSM rosée au poivre.`,
    images: [`${cloudfrontUrl}/food/katsu_burger.png`],
    isVisible: true,
  },
  {
    id: "seoul-corndog",
    name: "SEOUL CORNDOG",
    price: "7",
    category: Category.CORNDOG,
    description: `Le corn dog authentique de Corée, alliant saveurs sucrées et salées.`,
    images: [`${cloudfrontUrl}/food/corndog_classic2.png`],
    isVisible: true,
  },
  {
    id: "seoul-potato-corndog",
    name: "SEOUL POTATO CORNDOG",
    price: "8.0",
    category: Category.CORNDOG,
    description: `Le corn dog authentique de Corée, mélange de saveurs sucrées et salées,
enveloppé de cubes de pommes de terre.`,
    images: [`${cloudfrontUrl}/food/potato_corndog_classic2.png`],
    isVisible: true,
  },
  {
    id: "spicy-corndog",
    name: "SPICY CORNDOG",
    price: "7.5",
    category: Category.CORNDOG,
    description: `Une combinaison de sauce KSM Spicy, de sauce authentique épicée et de notre poudre épicée signature.`,
    images: [`${cloudfrontUrl}/food/corndog_spicy2.png`],
    isVisible: true,
  },
  {
    id: "spicy-potato-corndog",
    name: "SPICY POTATO CORNDOG",
    price: "8.5",
    category: Category.CORNDOG,
    description: `Une combinaison de sauce KSM Spicy, de sauce authentique épicée et de notre poudre épicée signature,
enveloppé de cubes de pommes de terre.`,
    images: [`${cloudfrontUrl}/food/potato_corndog_spicy.png`],
    isVisible: true,
  },
  {
    id: "cheese-corndog",
    name: "CHEESE CORNDOG",
    price: "7.5",
    category: Category.CORNDOG,
    description: `Saupoudré de notre assaisonnement signature KSM et servi avec des sauces fromagères.`,
    images: [`${cloudfrontUrl}/food/corndog_cheese2.png`],
    isVisible: true,
  },
  {
    id: "cheese-potato-corndog",
    name: "CHEESE POTATO CORNDOG",
    price: "8.5",
    category: Category.CORNDOG,
    description: `Saupoudré de notre assaisonnement signature KSM et servi avec des sauces fromagères,
enveloppé de cubes de pommes de terre.`,
    images: [`${cloudfrontUrl}/food/potato_corndog_cheese2.png`],
    isVisible: true,
  },
  {
    id: "chicken",
    name: "GOLDEN CHICKEN",
    price: "15.9",
    category: Category.CHICKEN,
    description: `Notre plat ADN signature. Hauts de cuisse de poulet désossés, assaisonnés de notre mélange d’épices secret,
cuits dans de l’huile de tournesol 100 % raffinée.
Un goût simple mais parfait, avec une texture croustillante et juteuse, accompagné de nos 3 sauces signature KSM.`,
    images: [
      `${cloudfrontUrl}/food/chicken.png`,
      `${cloudfrontUrl}/food/chicken2.png`,
    ],
    isVisible: true,
  },
  {
    id: "kimchi-coleslaw",
    name: "COLESLAW DE KIMCHI",
    price: "",
    category: Category.SIDE,
    description:
      "Une délicieuse version revisitée de la salade de chou classique, combinée avec du kimchi.",
    images: [`${cloudfrontUrl}/food/coleslaw_au_kimchi.png`],
    isVisible: false,
  },
  {
    id: "tteokbokki",
    name: "TTEOKBOKKI",
    price: "6",
    category: Category.SIDE,
    description: `Le Tteokbokki, street food emblématique coréenne : petits gâteaux de riz gluant servis dans une sauce sucrée-salée et piquante.`,
    images: [`${cloudfrontUrl}/food/Tteokbokki.png`],
    isVisible: true,
  },
  {
    id: "home-made-matchsticks-fries",
    name: "FRITES ALLUMETTE MAISON",
    price: "5",
    category: Category.SIDE,
    description: `Une harmonie de croustillant et de moelleux, selon la recette spéciale de KSM.
`,
    images: [`${cloudfrontUrl}/food/frites_maison.png`],
    isVisible: true,
  },
  {
    id: "bulgogi-fried-rice",
    name: "RIZ SAUTE AU BULGOGI",
    price: "7",
    category: Category.SIDE,
    description: `Un goût de BBQ coréen, sublimé par la douceur de la pomme de terre.
`,
    images: [`${cloudfrontUrl}/food/riz_saute_au_bulgogi.png`],
    isVisible: true,
  },
  {
    id: "chicken-dumpling-soup",
    name: "SOUPE DE RAVIOLIS AU POULET",
    price: "7",
    category: Category.SIDE,
    description: `Ravioles de poulet coréennes servies dans un bouillon de poulet assaisonné à la sauce soja.`,
    images: [`${cloudfrontUrl}/food/Soupe_de_ravioli_au_poulet.png`],
    isVisible: true,
  },
  {
    id: "sesame-oil-taboule",
    name: "TABOULE A L'HUILE DE SESAME",
    price: "7",
    category: Category.SIDE,
    description: `Un taboulé oriental relevé d’une touche coréenne.`,
    images: [`${cloudfrontUrl}/food/riz_saute_au_bulgogi2.png`],
    isVisible: true,
  },
  {
    id: "tofu-sesame-noodles",
    name: "NOUILLES AU TOFU ET AU SESAME",
    price: "7",
    category: Category.SIDE,
    description: `Capellini froids servis avec une sauce crémeuse au sésame et au tofu.`,
    images: [
      `${cloudfrontUrl}/food/nouilles_au_tofu_et_au_sésame.png`,
      `${cloudfrontUrl}/food/nouilles_au_tofu_et_au_sésame2.png`,
    ],
    isVisible: true,
  },
  {
    id: "salade-egg-potato",
    name: "SALADE D'OEUFS ET POMMES DE TERRE",
    price: "7",
    category: Category.SIDE,
    description: `Une salade de pommes de terre crémeuse et savoureuse, agrémentée d’œuf.`,
    images: [`${cloudfrontUrl}/food/taboule_a_l_huile_de_sesame.png`],
    isVisible: true,
  },
  {
    id: "salade-caesar-miso",
    name: "SALADE CESAR AU JANG MIS",
    price: "3",
    category: Category.SIDE,
    description: `Une salade César twistée par la saveur fermentée du soja coréen (doenjang).`,
    images: [`${cloudfrontUrl}/food/salade_cesar_au_doenjang.png`],
    isVisible: true,
  },
  {
    id: "mini-vegetable-pancakes",
    name: "MINI GALETTE DE LEGUMES COREENNE",
    price: "",
    category: Category.SIDE,
    description: `Une galette de légumes traditionnelle coréenne.
`,
    images: [`${cloudfrontUrl}/food/mini_galettes_de_legumes.png`],
    isVisible: false,
  },
  {
    id: "spritz-mont-berry-sans-alcool",
    name: "SPRITZ MONT BERRY SANS ALCOOL",
    price: "10",
    category: Category.COCKTAIL,
    description: `Un Spritz sans alcool qui allie fraîcheur et douceur : un thé à la fraise délicatement infusé, sublimé par de la purée de fraises fraîches et rehaussé d’un vin sans alcool pétillant. Léger, fruité et irrésistiblement rafraîchissant..
`,
    images: [`${cloudfrontUrl}/food/SpritzMontBerry_v1.png`],
    isVisible: true,
  },
  {
    id: "the-vert-au-yuzu-petillant-sans-alcool",
    name: "THÉ VERT AU YUZU PÉTILLANT SANS ALCOOL",
    price: "10",
    category: Category.COCKTAIL,
    description: `Un mocktail pétillant à base de thé yuzu coréen et de thé vert, garni de yuja infusé au thé vert.
`,
    images: [`${cloudfrontUrl}/food/ThevertYuzuPetillant_v1.png`],
    isVisible: true,
  },
  {
    id: "jujube-au-miel-a-l-ancienne",
    name: "JUJUBE AU MIEL À L'ANCIENNE",
    price: "12",
    category: Category.COCKTAIL,
    description: `Un cocktail à l’ancienne réinventé, où le thé de jujube infusé au miel rencontre les jujubes séchées délicatement caramélisées Garnies de sirop de caramel, les jujubes sont enveloppées dans un sirop sucré rappelant le caramel, pour une saveur et une texture noisettées..
`,
    images: [`${cloudfrontUrl}/food/JujubeMielAncienne_v1.png`],
    isVisible: true,
  },
  {
    id: "maesil-sweet-n-sour",
    name: "MAESIL SWEET N SOUR",
    price: "10",
    category: Category.COCKTAIL,
    description: `Un cocktail aigre-doux qui marie vin et extrait de prune, deux saveurs phares de la Corée, au calvados, emblématique liqueur française. Garni de poires marinées au sirop de miel, il capture parfaitement la saveur et la texture des poires coréennes, pour une expérience à la fois fruitée et raffinée.`,
    images: [`${cloudfrontUrl}/food/Maesil aigre-doux (sweet n sour)_v1.jpg`],
    isVisible: true,
  },
  {
    id: "omija-coke",
    name: "OMIJA COKE",
    price: "10",
    category: Category.COCKTAIL,
    description: `Un cocktail à base de liqueur d’omija, célèbre pour ses cinq saveurs. Garni de canneberges, framboises, poivre et une touche de sel, il révèle toute la richesse fruitée et légèrement épicée de l’omija, pour une expérience authentique et surprenante.
`,
    images: [`${cloudfrontUrl}/food/OmijaCoke_v1.png`],
    isVisible: true,
  },
  {
    id: "bulgogi-blood-mary",
    name: "BULGOGI BLOOD MARY",
    price: "10",
    category: Category.COCKTAIL,
    description: `Un Bloody Mary épicé revisité, préparé avec un jus de tomate maison relevé de sauce bulgogi et de la fameuse sauce Itaewon de KSM. Il est garni de gâteaux de riz marinés dans une sauce soja maison puis flambés, apportant une touche fumée et caramélisée qui sublime chaque gorgée.`,
    images: [`${cloudfrontUrl}/food/BulgogiBloodMary_v1.png`],
    isVisible: true,
  },
  {
    id: "ssamy-yammy",
    name: "SSAMY YAMMY",
    price: "12",
    category: Category.COCKTAIL,
    description: `Inspiré du SSAM coréen, ce cocktail surprend par son équilibre entre fraîcheur et gourmandise. Le prosciutto fond délicatement en bouche, tandis que les notes fruitées de jus d’ananas et de vin de yuzu viennent réveiller les saveurs. Les pousses d’épinards et légumes croquants apportent une touche subtile et légère, pour un voyage entre tradition coréenne et élégance française.`,
    images: [`${cloudfrontUrl}/food/ssamy yammy_v1.jpg`],
    isVisible: true,
  },
  {
    id: "doraji-negroni",
    name: "DORAJI NEGRONI",
    price: "10",
    category: Category.COCKTAIL,
    description: `Une réinterprétation du célèbre Negroni, où l’amertume classique se mêle à une note unique d’huile de périlla coréenne, apportant profondeur, parfum et une touche inattendue qui colore subtilement chaque gorgée.`,
    images: [`${cloudfrontUrl}/food/Doraji Negroni_v1.jpg`],
    isVisible: true,
  },
  {
    id: "dalgona-sesame-black-latte",
    name: "DALGONA SESAME NOIR LATTE",
    price: "6",
    category: Category.MATCHA_SMOOTHIE,
    description: `Savourez l'alliance onctueuse du sésame noir intense et de la crème dalgona. Cette crème au café est une version crémeuse du biscuit dalgona présenté dans la série Netflix « Squid Game ».`,
    images: [`${cloudfrontUrl}/food/ksmweb_sesamenoirdalgona.png`],
    isVisible: true,
  },

  {
    id: "matcha-strawberry-latte",
    name: "MATCHA STRAWBERRY LATTE",
    price: "6",
    category: Category.MATCHA_SMOOTHIE,
    description: `L'alliance du matcha riche et des fraises sucrées vous apportera du bonheur.`,
    images: [`${cloudfrontUrl}/food/ksmweb_matchastrawberrylatte.png`],
    isVisible: true,
  },
  {
    id: "matcha-chocolate-latte",
    name: "MATCHA CHOCOLAT LATTE",
    price: "6",
    category: Category.MATCHA_SMOOTHIE,
    description: `Le matcha et le chocolat forment une association très appréciée. L'ajout de chocolat sucré au matcha le rend encore plus délicieux.`,
    images: [`${cloudfrontUrl}/food/ksmweb_chocomatchalatte.png`],
    isVisible: true,
  },
  {
    id: "matcha-latte",
    name: "MATCHA LATTE",
    price: "6",
    category: Category.MATCHA_SMOOTHIE,
    description: `Savourez le goût doux-amer du matcha ! Il vous offre la véritable saveur du matcha.`,
    images: [`${cloudfrontUrl}/food/ksmweb_matchalatte.png`],
    isVisible: true,
  },

  {
    id: "fraise-latte",
    name: "FRAISE LATTE",
    price: "6",
    category: Category.MATCHA_SMOOTHIE,
    description: `Des fraises sucrées et du lait ! Que dire de plus ? `,
    images: [`${cloudfrontUrl}/food/ksmweb_fraiselatte.png`],
    isVisible: true,
  },
  {
    id: "milk-shake",
    name: "MILK SHAKE",
    price: "6",
    category: Category.MATCHA_SMOOTHIE,
    description: `Savourez un milkshake sucré, rafraîchissant et onctueux !`,
    images: [`${cloudfrontUrl}/food/ksmweb_milkshake.png`],
    isVisible: true,
  },
  {
    id: "mango-blended",
    name: "MANGO BLENDED",
    price: "6",
    category: Category.MATCHA_SMOOTHIE,
    description: `Découvrez le vrai goût de la mangue sucrée et riche !`,
    images: [`${cloudfrontUrl}/food/ksmweb_mangoblended.png`],
    isVisible: true,
  },
  {
    id: "strawberry-blended",
    name: "STRAWBERRY BLENDED",
    price: "6",
    category: Category.MATCHA_SMOOTHIE,
    description: `Savourez le goût riche et frais des fraises !`,
    images: [`${cloudfrontUrl}/food/ksmweb_strawberryblended.png`],
    isVisible: true,
  },
  {
    id: "rose-mango-ade",
    name: "ROSE MANGO ADE",
    price: "6",
    category: Category.MATCHA_SMOOTHIE,
    description: `Le goût de la mangue fraîche et du citron acidulé vous transportera en été.`,
    images: [`${cloudfrontUrl}/food/ksmweb_mangoroseade.png`],
    isVisible: true,
  },
  {
    id: "strawberry-lemon-ade",
    name: "STRAWBERRY LEMON ADE",
    price: "6",
    category: Category.MATCHA_SMOOTHIE,
    description: `L'alliance de la saveur authentique des fraises et du goût rafraîchissant du citron est désaltérante et se marie parfaitement avec tous les plats.`,
    images: [`${cloudfrontUrl}/food/ksmweb_strawberrylemonade.png`],
    isVisible: true,
  },
  {
    id: "yuzu-matcha-ade",
    name: "YUZU MATCHA ADE",
    price: "6",
    category: Category.MATCHA_SMOOTHIE,
    description: `Une combinaison rafraîchissante de yuzu sucré et de matcha amer ! Savourez ce goût sucré-amer que tout le monde adore.`,
    images: [`${cloudfrontUrl}/food/ksmweb_matchayuzuade.png`],
    isVisible: true,
  },
  {
    id: "glace-matcha",
    name: "GLACE AU MATCHA",
    price: "5",
    category: Category.DESSERT,
    description: `Une glace onctueuse et sucrée au bon goût de matcha !`,
    images: [`${cloudfrontUrl}/food/ksmweb_glace_matcha.png`],
    isVisible: true,
  },
  {
    id: "glace-sesame-noir",
    name: "GLACE AU SÉSAME NOIR",
    price: "5",
    category: Category.DESSERT,
    description: `Vous aimez les saveurs riches ? Savourez la saveur riche par excellence : le sésame noir.`,
    images: [`${cloudfrontUrl}/food/ksmweb_glace_sesame.png`],
    isVisible: true,
  },
  {
    id: "glace-sunda-lait",
    name: "GLACE SUNDAE AU LAIT",
    price: "5",
    category: Category.DESSERT,
    description: `Une glace onctueuse et sucrée au bon goût de lait ! Le dessert préféré de tous.`,
    images: [`${cloudfrontUrl}/food/ksmweb_glace_lait.png`],
    isVisible: true,
  },
];

export const sideByCategory: SideByCategory = {
  [Category.SIGATURE_PLATTER]: {
    description: `Plat signature aux saveurs coréennes : un voyage gourmand où se mêlent épices, textures et couleurs, à savourer en duo, comme un véritable rituel de convivialité.
    6 PIECES DE POULET
    GURAN-ZZIM
    BANCHAN: Radis mariné/Kimchi de carotte/Oignons marinés
    NOUILLES CAPELLINI AU SESAME Sauvage
    2 MINI BURGURS MAISON`,
    cold: [],
    hot: [],
  },
  [Category.CORNDOG]: {
    description:
      "Corndogs maison, symbole de la street-food coréenne : saucisse de poulet enrobée d'une pâte artisanale, frits minute pour un croustillant doré et gourmand.",
    cold: ["kimchi-coleslaw", "sesame-oil-taboule", "salade-egg-potato"],
    hot: [
      "home-made-matchsticks-fries",
      "mini-vegetable-pancakes",
      "tteokbokki",
    ],
  },
  [Category.BURGER]: {
    description:
      "Burgers signature, entre pain artisanal et poulet mariné croustillant à cœur, sublimés sauces originales, toutes élaborées maison.",
    cold: ["kimchi-coleslaw", "sesame-oil-taboule", "salade-egg-potato"],
    hot: [
      "home-made-matchsticks-fries",
      "mini-vegetable-pancakes",
      "tteokbokki",
    ],
  },
  [Category.CHICKEN]: {
    description:
      "Trois pièces de cuisse poulet fermier et desossés, marinés avec soin et enrobés d'une panure maison, frits minute pour un croustillant doré et une saveur unique.",
    cold: ["kimchi-coleslaw", "sesame-oil-taboule", "salade-egg-potato"],
    hot: [
      "home-made-matchsticks-fries",
      "mini-vegetable-pancakes",
      "tteokbokki",
    ],
  },
  [Category.SIDE]: {
    description: `Entrées revisitées, inspirées des saveurs coréennes et pensées pour les petites faims :
des bouchees creatives et gourmandes a déguster seules ou a partager.`,
    cold: [],
    hot: [],
  },
  [Category.COCKTAIL]: {
    description: `Découvrez un cocktail qui vous fera goûter de la vraie Corée. De Sans alcool a mocktail, choisissez parmi une variété de cocktails pour vous mettre en appétit.`,
    cold: [],
    hot: [],
  },
  [Category.MATCHA_SMOOTHIE]: {
    description: `Nous vous présentons une boisson à la fois familière et inédite. Nous proposons une variété de saveurs coréennes, dont un délicieux matcha et un riche sésame noir, tous préparés en Corée.`,
    cold: [],
    hot: [],
  },
  [Category.DESSERT]: {
    description: `Savourez une glace au goût riche, délicieuse après un repas ou tout simplement nature.`,
    cold: [],
    hot: [],
  },
};
